import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { GlobalsService } from 'app/globals-services/globals.service';
import { BrandFactoryConnectionService } from 'app/shared/services/brand-factory-connection.service';

@Component({
  selector: 'app-sent-request-list',
  templateUrl: './sent-request-list.component.html',
  styleUrls: ['./sent-request-list.component.scss']
})
export class SentRequestListComponent implements OnInit {


  dataSource: MatTableDataSource<any> = null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input("type") type = 1

  displayedColumns: string[] = [
    'CompanyName',
    // 'Role', 
    // 'Supplier ID', 
    // 'Walmart Mill ID',
    'countryName',
    'requestDate',
    'ConnectionStatus',
    'delete'
  ];

  statusFilter = 0;
  page = 0;
  pageSize = 10;
  totalCount = 0;

  constructor(
    private globalServices: GlobalsService,
    private toastService: ToastService,
    private brandFactoryConnectionService: BrandFactoryConnectionService
  ) {

  }

  ngOnInit(): void {

    this.globalServices.showSpinner()
    this.brandFactoryConnectionService.commonSubject$.subscribe(res => {
      if (res['loadLatestConnection']) {
        this.countBrandConnectionRequest()
      }
      this.globalServices.hideSpinner()
    })
    this.countBrandConnectionRequest()
  }

  // @ Count the Brand Connection Request Method
  countBrandConnectionRequest() {
    let data = {
      requestFrom: this.globalServices.profile['id'],
      status: this.statusFilter == -1 ? null : this.statusFilter,
      type: this.type
    }
    this.totalCount = 0;
    this.globalServices.showSpinner()
    this.brandFactoryConnectionService.sentConnectionRequestCount(data).subscribe(
      (response) => {

        this.globalServices.hideSpinner()
        if (response['count'] > 0) {
          this.brandConnectionRequestList();
          this.totalCount = response['count'];
        } else {
          this.dataSource ? this.dataSource.data = [] : this.dataSource = null;
        }


      },
      (error) => {
        this.globalServices.hideSpinner()
        return 0;
      }
    );

  }

  // @ Get the List Of Brand Connections Request Method
  brandConnectionRequestList() {
    let data = {
      requestFrom: this.globalServices.profile['id'],
      page: this.page,
      pageSize: this.pageSize,
      status: this.statusFilter == -1 ? null : this.statusFilter,
      type: this.type
    }

    this.globalServices.showSpinner();
    this.brandFactoryConnectionService.sentConnectionRequestList(data).subscribe(
      (response) => {
        //  this.suppliers = response;
        let finalList = response.filter(r => r.status != 1)
        this.dataSource = new MatTableDataSource(finalList);
        this.globalServices.hideSpinner();

      },
      (error) => {
        this.globalServices.hideSpinner();
        return 0;
      }
    );
  }

  onStatusFilterChnage(status) {
    if (status != this.statusFilter) {
      this.statusFilter = status
      this.countBrandConnectionRequest()
    }
  }

  onPageChange(event) {
    this.page = this.paginator.pageIndex,
      this.pageSize = this.paginator.pageSize
    this.brandConnectionRequestList();
  }

  deleteConnectionRequest(id) {
    this.globalServices.showSpinner()
    this.brandFactoryConnectionService.deleteConnectionRequest(id).subscribe(
      (response) => {
        this.toastService.success("Request removed successfully")
        this.countBrandConnectionRequest();

      },
      (error) => {
        this.globalServices.hideSpinner()
        return 0;
      }
    );

  }

}
